import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import objectPath from "object-path";

import KTToggle from "_metronic/_assets/js/toggle";
import * as builder from "_metronic/ducks/builder";
import NotificationListToggler from "_metronic/layout/header/NotificationListToggler";

const HeaderMobile = () => {
  const toggleButtonRef = useRef();

  // Redux selectors using useSelector hook
  const asideDisplay = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "aside.self.display")
  );
  const headerMobileCssClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "header_mobile",
      toString: true,
    })
  );
  const headerMobileAttributes = useSelector((store) =>
    builder.selectors.getAttributes(store, {
      path: "aside_menu",
    })
  );

  useEffect(() => {
    const toggleOptions = {
      target: "body",
      targetState: "kt-header__topbar--mobile-on",
      togglerState: "kt-header-mobile__toolbar-topbar-toggler--active",
    };
    new KTToggle(toggleButtonRef.current, toggleOptions);
  }, []);

  return (
    <div
      id="kt_header_mobile"
      className={`kt-header-mobile align-items-center ${headerMobileCssClasses}`}
      {...headerMobileAttributes}
    >
      {
        // <div className="kt-header-mobile__logo">
        //   <Link to="/">
        //     <img alt="logo" src={headerLogo} />
        //   </Link>
        // </div>
      }

      <div className="kt-header-mobile__toolbar">
        {asideDisplay && (
          <button
            className="kt-header-mobile__toggler kt-header-mobile__toggler--left"
            id="kt_aside_mobile_toggler"
          >
            <span />
          </button>
        )}
      </div>

      <div className="actions flex-grow-1 d-flex justify-content-end f-20">
        <NotificationListToggler toggleBy="kt_notification_list_toggler_btn_mobile" />
      </div>
    </div>
  );
};

export default HeaderMobile;
